import { Container, Sprite } from 'pixi.js';

import { Shared } from '../../App';

export class BillboardPedal extends Container
{
    private pedalUp: Sprite;
    private pedalDown: Sprite;

    constructor(type: 'acc' | 'brake' = 'acc')
    {
        super();
        this.pedalUp = new Sprite(Shared.assets.getTexture(`${type}-pedal-up`));
        this.pedalUp.anchor.set(0.5);
        this.addChild(this.pedalUp);

        this.pedalDown = new Sprite(Shared.assets.getTexture(`${type}-pedal-down`));
        this.pedalDown.anchor.set(0.5);
        this.pedalDown.x = -50;
        this.addChild(this.pedalDown);
    }

    public press(): void
    {
        this.pedalUp.renderable = false;
        this.pedalDown.renderable = true;
    }

    public release(): void
    {
        this.pedalUp.renderable = true;
        this.pedalDown.renderable = false;
    }
}
